import styled from 'styled-components';

export const StyledUserMenu = styled.div`
  display: flex;
  align-items: center;
`;
